import { render, staticRenderFns } from "./InfoViewer.vue?vue&type=template&id=6b271bce&scoped=true&"
import script from "./InfoViewer.vue?vue&type=script&lang=js&"
export * from "./InfoViewer.vue?vue&type=script&lang=js&"
import style0 from "./InfoViewer.vue?vue&type=style&index=0&id=6b271bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b271bce",
  null
  
)

export default component.exports